import { type MotifComponent, type MotifComponentProps, m } from '../../motif';
import { contrastBlackFormVars, formVars } from './Form.palette';

export const snapFormPrimaryVars: MotifComponentProps<MotifComponent.FORM> = {
  ...formVars,
  '--form-input-hover-border-color': m('--neutral-v600'),
  '--form-input-border-color': m('--neutral-v700'),
  '--form-input-hover-box-shadow': 'none',
  '--form-input-active-box-shadow': 'none',
  '--form-input-border-radius': '0px',
  '--form-input-checkbox-border-radius': '0px',
};

export const snapFormSecondaryVars: MotifComponentProps<MotifComponent.FORM> = {
  ...contrastBlackFormVars,
  '--form-input-hover-box-shadow': 'none',
  '--form-input-active-box-shadow': 'none',
  '--form-input-border-radius': '0px',
  '--form-input-checkbox-border-radius': '0px',
};
